class BlueListbox extends ListBox {
    constructor(identifier: string, container: JQuery, controller: Controller, mode: string) {
        super(identifier, controller, container, mode);
    }

    initHTML(oldContainer: JQuery) {
        this.allowMultiple = oldContainer.attr("multiple") == "multiple";
    }

    setSelection (selection) {
        this.container.find("option").each(function(index) {
            if(selection[index]) {
                $(this).attr('selected', 'selected');
                $(this).prop('selected', 'selected');
            } else {
                $(this).removeAttr('selected').change();
                $(this).removeAttr('selected').change();
            }
        });
    }

    getSelection () {
        var result = [];

        this.container.find("option").each(function(index) {
            result.push($(this).is(':selected'));
        });

        return result;
    }

    previewSelection(selection: boolean[], timeRatioLeft: number) {
        for(var i = 0; i < selection.length; i++) {
            let option = this.container.find("option:eq(" + i + ")");

            if(option.is(':selected') && !selection[i]) {
                option.addClass("feedforward_deselected")
            } else if(!option.is(':selected') && selection[i]) {
                option.addClass("feedforward_selected")
            }
        }
    }
    removePreviewSelection() {
        this.container.find("option").removeClass("feedforward_selected");
        this.container.find("option").removeClass("feedforward_deselected");
    }
}